/**
 * Módulo: Supervisión
 * Grupo del sidebar para vistas de supervisión / control (oversight).
 *
 * Creado 7-jul-2026 (Mariano) como sección nueva debajo de Gestión.
 * Arranca con accesos a Casos y Proyectos.
 *
 * Nota: acá viven solo los ÍTEMS del menú (mismo patrón que Calendario/
 * Mensajes/Mis casos → la ruta sigue en el módulo de origen). Las rutas
 * /casos y /proyectos las montan casos/config.js y proyectos/config.js.
 */
export default {
  id: 'supervision',
  nombre: 'Supervisión',
  descripcion: 'Vistas de supervisión y control',
  icono: 'activity',
  tipo: 'core',
  version: '0.1.0',
  // Staff (admin + consultores). Clientes usan el Portal.

  // Sin rutas propias: los ítems apuntan a rutas de casos/ y proyectos/.
  routes: [],

  menuItems: [
    { label: 'Casos', path: '/casos', icon: 'folder', permisoModulo: 'casos' },
    { label: 'Proyectos', path: '/proyectos', icon: 'check-square', permisoModulo: 'proyectos' },
  ],

  features: [],

  // El grupo se muestra si el rol tiene 'ver' sobre casos o proyectos
  // (o es Wizard, que ve todo el catálogo).
  permisoModulos: ['casos', 'proyectos'],

}
